import React from "react";
import { langText } from "../../../recoil/lang";
import { FooterButtonViewProps } from "./type";
import { Style } from "./style";

const FooterButtonView = ({ props, hook }: FooterButtonViewProps) => {
  return (
    <Style>
      <div className="sideButtonWrap">
        {props.storeList &&
          props.storeList?.order_section?.order_check_cnt > 0 && (
            <button
              className={`sideButton contact`}
              onClick={hook.handleCustomerServiceClick}
            >
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_service.svg`}
                alt="고객센터"
              />
              <img
                className="siren"
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_siren.svg`}
                alt="siren"
              />
              {(hook.newChatListFlag.length > 0 || hook.csChatListFlag) && (
                <div className="count">
                  <h3>N</h3>
                </div>
              )}
              <div className="request">
                <p>{langText.customer_service[hook.lang]}</p>
              </div>
            </button>
          )}
        {hook.conciergeCheck() && !hook.interphoneCheck() && (
          <button className={`sideButton`} onClick={hook.handleConciergeClick}>
            <img
              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_clerk.svg`}
              alt="컨시어지"
            />
            <div className="request">
              <p>{langText.conciergeModal_button_submit[hook.lang]}</p>
            </div>
          </button>
        )}
        {hook.cart.length > 0 && (
          <button className={`sideButton`} onClick={hook.handleCartClick}>
            <img
              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_cart.svg`}
              alt="장바구니"
            />
            <div className="count">
              <h3>{hook.cartQuantitiy}</h3>
            </div>
            <div className="request">
              <p>{langText.cart[hook.lang]}</p>
            </div>
          </button>
        )}
      </div>
    </Style>
  );
};
export default FooterButtonView;
